import { MDBBtn, MDBSpinner } from "mdb-react-ui-kit";
import React from "react";
const Loader = ({ isloading = false, message = "Loading..." }) => {
  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
};
export default Loader;
